/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type sidebarMenu_viewer = {
    readonly notifications: {
        readonly unreadBroadcastNotifications: number;
    } | null;
    readonly user: {
        readonly username: string;
        readonly entities: ReadonlyArray<{
            readonly accountName: string | null;
        }>;
        readonly roles: ReadonlyArray<{
            readonly name: string;
        }>;
        readonly isHub: boolean;
    } | null;
    readonly " $refType": "sidebarMenu_viewer";
};
export type sidebarMenu_viewer$data = sidebarMenu_viewer;
export type sidebarMenu_viewer$key = {
    readonly " $data"?: sidebarMenu_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"sidebarMenu_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "sidebarMenu_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ViewerNotifications",
      "kind": "LinkedField",
      "name": "notifications",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unreadBroadcastNotifications",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Entity",
          "kind": "LinkedField",
          "name": "entities",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accountName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "roles",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isHub",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '0daba5dfc2c3f9fa46e64d0b41c10973';
export default node;
